import { render, staticRenderFns } from "./InfoFooter.vue?vue&type=template&id=21c0fdca&"
import script from "./InfoFooter.vue?vue&type=script&lang=js&"
export * from "./InfoFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports